import { ICurrencies } from "@domain/version2/Currencies"
import apiClient from "@util/ApiClient"

export default class CurrenciesApi {
    static getListCurrencies(): Promise<{ data: ICurrencies[] }> {
        return apiClient.get("currencies")
    }
}
